export enum LocationTypeNames {
  Depot = "Depot",
  Customer = "Customer"
};

export class LocationClassNameHelper {
  static getLocationClassName(type: string) {
    return type == LocationTypeNames.Depot 
      ? "depot" 
      : type == LocationTypeNames.Customer 
        ? "customer" 
        : "tipping";
  }

  static getLocationColour(type: string) {
    return type == LocationTypeNames.Depot 
        ? "#2978ff" 
        : type == LocationTypeNames.Customer 
          ? "#00c07f" 
          : "#fec107";
  }
}

